const STOCK_COMMAND_PKG = {
    navTitle: "Stocks",
    routerName: "StocksDocs",
    commandsDescription: "Price, Find Ticker, Bio, etc...",

    commandList: [
        {
            title: "Price",
            routerRef: "price",
            commandString: "!stock <Symbol>",
            description: "Shows the price, change percentage, volume, and other information about a given stock",
            parameters: [
                { name: "Symbol: ", desc: "The symbol/ticker of the stock you want the price of" },
            ],
            examples: [
                "!stock GOOGL",
                "!stock AMD"
            ],
            type: "Stocks", 
            shortcuts: ["none"]
        },

        {
            title: "Find Ticker",
            routerRef: "find-ticker",
            commandString: "!findticker <Company>",
            description: "Shows the ticker symbol for a given company name",
            parameters: [
                { name: "Company: ", desc: "The name of the company that you want to know the ticker of" },
            ],
            examples: [
                "!findticker Google",
                "!findticker Advanced Micro Devices"
            ],
            type: "Stocks", 
            shortcuts: ["none"]
        },
        {
            title: "Bio",
            routerRef: "bio",
            commandString: "!bio <Symbol>",
            description: "Get Bio of a stock from Google",
            parameters: [
                { name: "Symbol: ", desc: "The symbol/ticker of the stock you want the bio of" },
            ],
            examples: [
                "!bio GOOGL",
                "!bio AMD"
            ],
            type: "Stocks", 
            shortcuts: ["none"]
        },
        {
            title: "House of Representative's Trading",
            routerRef: "housetrades",
            commandString: "!housetrades <Symbol>",
            description: "Get the latest trading from the US House - can add Symbol after to query on that",
            parameters: [
                { name: "Symbol: ", desc: "Optionable parameter - The symbol/ticker of the stock you want to sort by of" },
            ],
            examples: [
                "!housetrading",
                "!housetrading AMD"
            ],
            type: "Stocks",
            shortcuts: ["none"]
        },
        {
            title: "Senate Trading",
            routerRef: "senatetrades",
            commandString: "!senatetrades <Symbol>",
            description: "Get the latest trading from the US Senate - can add Symbol after to query on that",
            parameters: [
                { name: "Symbol: ", desc: "Optionable parameter - The symbol/ticker of the stock you want to sort by of" },
            ],
            examples: [
                "!senatetrades",
                "!senatetrades AMD"
            ],
            type: "Stocks",
            shortcuts: ["none"]
        },
        {
            title: "Government Contracts",
            routerRef: "govcontracts",
            commandString: "!govcontracts <Symbol>",
            description: "Get the latest Government Contract Amounts - sorted by amount - can add Symbol after to query on that",
            parameters: [
                { name: "Symbol: ", desc: "Optionable parameter - The symbol/ticker of the stock you want to sort by of" },
            ],
            examples: [
                "!govcontracts",
                "!govcontracts LMT"
            ],
            type: "Stocks",
            shortcuts: ["none"]
        },
        {
            title: "Halts",
            routerRef: "halts",
            commandString: "!halt <Symbol>",
            description: "Gives Time and Halt Code of a halted stock",
            parameters: [
                { name: "Symbol: ", desc: "The symbol/ticker of the stock you're looking for" },
            ],
            examples: [
                "!halt GOOGL",
                "!halt AMD"
            ],
            type: "Stocks", 
            shortcuts: ["none"]
        },
        {
            title: "Insider Transactions",
            routerRef: "insider",
            commandString: "!insider <Symbol>",
            description: "Insider transaction summary for last 3 and 12 month period",
            parameters: [
                { name: "Symbol: ", desc: "The symbol/ticker of the stock" },
            ],
            examples: [
                "!insider GOOGL",
                "!insider AMD"
            ],
            type: "Stocks", 
            shortcuts: ["none"]
        },
        {
            title: "Institutional Holdings",
            routerRef: "instholdings",
            commandString: "!instholdings  <Symbol>",
            description: "Top 10 institutional holdings of stock",
            parameters: [
                { name: "Symbol: ", desc: "The symbol/ticker of the stock" },
            ],
            examples: [
                "!instholdings GOOGL",
                "!instholdings AMD"
            ],
            type: "Stocks",
            shortcuts: ["none"]
        },
        {
            title: "Institutional Difference",
            routerRef: "instdif",
            commandString: "!instdif  <Symbol>",
            description: "Sorts Institutional holdings by the difference in shares",
            parameters: [
                { name: "Symbol: ", desc: "The symbol/ticker of the stock" },
            ],
            examples: [
                "!instdif GOOGL",
                "!instdif AMD"
            ],
            type: "Stocks",
            shortcuts: ["none"]
        },
        {
            title: "Company Financials",
            routerRef: "financials",
            commandString: "!financials <Symbol>",
            description: "Returns Total Assets, Cash, Debt, Liabilities and Revenue for company",
            parameters: [
                { name: "Symbol: ", desc: "The symbol/ticker of the stock" },
            ],
            examples: [
                "!financials GOOGL",
                "!financials AMD"
            ],
            type: "Stocks", 
            shortcuts: ["fin"]
        },
        {
            title: "Dividend Info",
            routerRef: "divinfo",
            commandString: "!divinfo <Symbol>",
            description: "Dividend return and exDividend date",
            parameters: [
                { name: "Symbol: ", desc: "The symbol/ticker of the stock" },
            ],
            examples: [
                "!divinfo GOOGL",
                "!divinfo AMD"
            ],
            type: "Stocks", 
            shortcuts: ["none"]
        },
        {
            title: "ARK Buy/Sells",
            routerRef: "ark",
            commandString: "!ark",
            description: "ARK ETF buy/sells",
            parameters: ["none"],
            examples: [
                "!ark"
            ],
            type: "Stocks",
            shortcuts: ["none"]
        },
        {
            title: "CEO/CFO Buys",
            routerRef: "ceobuy",
            commandString: "!ceobuy",
            description: "Last 15 CEO/CFO buys $25k +",
            parameters: ["none"],
            examples: [
                "!ceobuy"
            ],
            type: "Stocks", 
            shortcuts: ["none"]
        },
        {
            title: "CEO/CFO Sells",
            routerRef: "ceosell",
            commandString: "!ceosell",
            description: "Last 15 CEO/CFO sells $25k +",
            parameters: ["none"],
            examples: [
                "!ceosell"
            ],
            type: "Stocks", 
            shortcuts: ["none"]
        },
        {
            title: "Pipeline",
            routerRef: "pipeline",
            commandString: "!pipeline <Symbol>",
            description: "Up to 10 drugs in Pipeline for a stock",
            parameters: [
                { name: "Symbol: ", desc: "The symbol/ticker of the stock" },
            ],
            examples: [
                "!pipeline GOOGL",
                "!pipeline AMD"
            ],
            type: "Stocks", 
            shortcuts: ["none"]
        },
        {
            title: "Price Target",
            routerRef: "pricetarget",
            commandString: "!pricetarget <Symbol>",
            description: "Returns Average, High, and Low Price Target for Company",
            parameters: [
                { name: "Symbol: ", desc: "The symbol/ticker of the stock" },
            ],
            examples: [
                "!pricetarget GOOGL",
                "!pricetarget AMD"
            ],
            type: "Stocks", 
            shortcuts: ["none"]
        },
        {
            title: "Detailed Insider Transactions",
            routerRef: "detinsider",
            commandString: "!detinsider <Symbol>",
            description: "Detailed insider transactions - last 6",
            parameters: [
                { name: "Symbol: ", desc: "The symbol/ticker of the stock" },
            ],
            examples: [
                "!detinsider GOOGL",
                "!detinsider AMD"
            ],
            type: "Stocks", 
            shortcuts: ["none"]
        },
        {
            title: "StockTwits Trending",
            routerRef: "stockwits",
            commandString: "!trendingST ",
            description: "Returns the top Trending Tickers from StockTwits",
            parameters: ["none"],
            examples: [
                "!trendingST"
            ],
            type: "Stocks", 
            shortcuts: ["none"]
        },
        {
            title: "Press Release",
            routerRef: "pr",
            commandString: "!pr <Symbol>",
            description: "Returns the latest Press Releases from Company – Benzinga",
            parameters: [
                { name: "Symbol: ", desc: "The symbol/ticker of the stock" },
            ],
            examples: [
                "!pr GOOGL",
                "!pr AMD"
            ],
            type: "Stocks", 
            shortcuts: ["none"]
        },
        {
            title: "Split History",
            routerRef: "split",
            commandString: "!split <Symbol>",
            description: "History of Stock Splits for company",
            parameters: [
                { name: "Symbol: ", desc: "The symbol/ticker of the stock" },
            ],
            examples: [
                "!split GOOGL",
                "!split AMD"
            ],
            type: "Stocks", 
            shortcuts: ["none"]
        },
        {
            title: "Company Website",
            routerRef: "website",
            commandString: "!website <Symbol>",
            description: "Get website for company",
            parameters: [
                { name: "Symbol: ", desc: "The symbol/ticker of the stock" },
            ],
            examples: [
                "!website GOOGL",
                "!website AMD"
            ],
            type: "Stocks", 
            shortcuts: ["none"]
        },
        {
            title: "Year-To-Date Performance",
            routerRef: "ytd",
            commandString: "!ytd <Symbol>",
            description: "Year to Date performance of stock with many other performance timeframes",
            parameters: [
                { name: "Symbol: ", desc: "The symbol/ticker of the stock" },
            ],
            examples: [
                "!ytd GOOGL",
                "!ytd AMD"
            ],
            type: "Stocks", 
            shortcuts: ["none"]
        },
        {
            title: "Stock Stats",
            routerRef: "stat",
            commandString: "!stat <Symbol>",
            description: "52 week high/low, short interest/float, and 200/50 day MA",
            parameters: [
                { name: "Symbol: ", desc: "The symbol/ticker of the stock" },
            ],
            examples: [
                "!stat GOOGL",
                "!stat AMD"
            ],
            type: "Stocks", 
            shortcuts: ["none"]
        },
        {
            title: "Streak",
            routerRef: "streak",
            commandString: "!streak <Symbol>",
            description: "Current Streak for stock - Days green or red in a row",
            parameters: [
                { name: "Symbol: ", desc: "The symbol/ticker of the stock" },
            ],
            examples: [
                "!streak GOOGL",
                "!streak AMD"
            ],
            type: "Stocks", 
            shortcuts: ["none"]
        },
        {
            title: "Technical Levels",
            routerRef: "ta",
            commandString: "!ta <Symbol>",
            description: "Returns the support and resistance levels (daily) and fib - Refreshed once a day.",
            parameters: [
                { name: "Symbol: ", desc: "The symbol/ticker of the stock" },
            ],
            examples: [
                "!ta GOOGL",
                "!ta AMD"
            ],
            type: "Stocks", 
            shortcuts: ["none"]
        },
        {
            title: "Stock News",
            routerRef: "news",
            commandString: "!news <Symbol>",
            description: "Returns the latest news on a stock - will add otc support later",
            parameters: [
                { name: "Symbol: ", desc: "The symbol/ticker of the stock" },
            ],
            examples: [
                "!news GOOGL",
                "!news AMD"
            ],
            type: "Stocks", 
            shortcuts: ["none"]
        },
        {
            title: "Stock Peers",
            routerRef: "peers",
            commandString: "!peers <Symbol>",
            description: "Returns Peers in the industry for specific stock",
            parameters: [
                { name: "Symbol: ", desc: "The symbol/ticker of the stock" },
            ],
            examples: [
                "!peers GOOGL",
                "!peers AMD"
            ],
            type: "Stocks", 
            shortcuts: ["none"]
        },
        {
            title: "P/E Ratio",
            routerRef: "peratio",
            commandString: "!peratio <Symbol>",
            description: "PE ratio of stock",
            parameters: [
                { name: "Symbol: ", desc: "The symbol/ticker of the stock" },
            ],
            examples: [
                "!peratio GOOGL",
                "!peratio AMD"
            ],
            type: "Stocks", 
            shortcuts: ["none"]
        },
        {
            title: "ZMF Score",
            routerRef: "zmf",
            commandString: "!zmf <Symbol>",
            description: "Get Z M and F Score for a stock",
            parameters: [
                { name: "Symbol: ", desc: "The symbol/ticker of the stock" },
            ],
            examples: [
                "!zmf GOOGL",
                "!zmf AMD"
            ],
            type: "Stocks", 
            shortcuts: ["none"]
        },
        {
            title: "Short Rate",
            routerRef: "shortrate",
            commandString: "!shortrate <Symbol>",
            description: "Sourced from Interactive Brokers - updated hourly - Borrow/Short Rate for a stock",
            parameters: [
                { name: "Symbol: ", desc: "The symbol/ticker of the stock" },
            ],
            examples: [
                "!shortrate GOOGL",
                "!shortrate AMD"
            ],
            type: "Stocks",
            shortcuts: ["none"]
        },
        {
            title: "Analyst Ratings",
            routerRef: "analyst",
            commandString: "!analyst <Symbol>",
            description: "Recent Analyst Ratings for stock",
            parameters: [
                { name: "Symbol: ", desc: "The symbol/ticker of the stock" },
            ],
            examples: [
                "!analyst GOOGL",
                "!analyst AMD"
            ],
            type: "Stocks", 
            shortcuts: ["none"]
        },
        {
            title: "Simple Moving Average",
            routerRef: "sma",
            commandString: "!sma <Symbol>",
            description: "Simple Moving Averages for a stock",
            parameters: [
                { name: "Symbol: ", desc: "The symbol/ticker of the stock" },
            ],
            examples: [
                "!sma GOOGL",
                "!sma AMD"
            ],
            type: "Stocks", 
            shortcuts: ["none"]
        },
        {
            title: "Short Interest",
            routerRef: "shortint",
            commandString: "!shortint <Symbol>",
            description: "Last 3 Short Interest values",
            parameters: [
                { name: "Symbol: ", desc: "The symbol/ticker of the stock" },
            ],
            examples: [
                "!shortint GOOGL",
                "!shortint AMD"
            ],
            type: "Stocks", 
            shortcuts: ["none"]
        },
        {
            title: "Stock Ratios",
            routerRef: "ratios",
            commandString: "!ratios <Symbol>",
            description: "Beta, Debt To Equity, ForwardPE, PE, Price to Book, Price to Sales",
            parameters: [
                { name: "Symbol: ", desc: "The symbol/ticker of the stock" },
            ],
            examples: [
                "!ratios GOOGL",
                "!ratios AMD"
            ],
            type: "Stocks", 
            shortcuts: ["none"]
        },
        {
            title: "SEC",
            routerRef: "sec",
            commandString: "!sec <Symbol>",
            description: "Returns the latest sec filings for a stock",
            parameters: [
                { name: "Symbol: ", desc: "The symbol/ticker of the stock" },
            ],
            examples: [
                "!sec GOOGL",
                "!sec AMD"
            ],
            type: "Stocks", 
            shortcuts: ["none"]
        },
    ]
}


export {STOCK_COMMAND_PKG};